<template>
  <el-container class="full-container">
    <!-- 侧边 -->
    <el-aside class="print-hide" width="200px">
      <side-bar>
        <div slot="trademark" class="title-box" @click="toIndex">
          <img src="../assets/images/ic_home_logo.png" />
          <!-- <span>管理后台</span> -->
        </div>

        <div slot="router" class="scroll-menu">
          <component
            :is="item.children && item.children.length ? 'sub-menu' : 'menu-item'"
            v-for="item in menuList"
            :key="item.name"
            :data="item"
          />
        </div>
      </side-bar>
    </el-aside>
    <el-container class="full-height bg-gray">
      <!-- 头部 -->
      <el-header class="no-padding index-header print-hide">
        <top-bar />
      </el-header>
      <!-- 主体 -->
      <div id="page-container" class="main">
        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="keepAliveComponents">
            <router-view :key="$route.path" />
          </keep-alive>
        </transition>
      </div>
    </el-container>
  </el-container>
</template>
<script>
/* eslint-disable space-infix-ops */

import TopBar from "../components/TopBar";
import SideBar from "../components/side-bar";
import MenuItem from "../components/side-bar/menu-item";
import SubMenu from "../components/side-bar/sub-menu";
import { pms2MenuList, decrypt } from "../filters/filter";
import { mapState } from "vuex";
import { getRoleDetail } from "@/api/auth";
import Utils from "@/jslibs/utils";
import { encrypt } from "@/filters/filter";
import { mapMutations } from "vuex";

export default {
  name: "Index",
  components: {
    TopBar,
    SideBar,
    MenuItem,
    SubMenu,
  },
  data() {
    return {
      menuList: [],
      newOrders: [],
      dialogVisible: false,
      noChildMunuList: ["积分设置", "消息推送", "数据统计"],
    };
  },

  computed: {
    ...mapState(["permissionList", "keepAliveComponents"]),
  },

  watch: {},
  async created() {
    if (this.permissionList instanceof Array && !this.permissionList.length) {
      return this.$router.replace("/login");
    }
    console.log(this.permissionList, "this.permissionListthis.permissionListthis.permissionListthis.permissionList");
    this.menuList = pms2MenuList(JSON.parse(decrypt(this.permissionList)));
    console.log(this.menuList, "menuListmenuListmenuListmenuListmenuList");
    localStorage.setItem("mymenus", JSON.stringify(this.menuList));
    const id = Utils.getCookie("X-Access-Group");
    if (id) {
      var {
        group: { rule_tree },
      } = await getRoleDetail(id);
      console.log(rule_tree, "rule_tree");
      console.log(id, "id");
      const permissionList = [];
      const operationList = [];
      // console.log(rule_tree)
      if (rule_tree instanceof Array) {
        rule_tree.forEach((one) => {
          const children = [];
          // 只有一级时
          if (this.noChildMunuList.includes(one.menu_name)) {
            if (one.son_rule) {
              const three = one.son_rule;
              operationList.push({
                name: one.menu_name,
                operations: three.map((i) => i.menu_name),
              });
            }
          }
          if (one.son_rule) {
            one.son_rule.forEach((two) => {
              if (!this.noChildMunuList.includes(one.menu_name)) {
                children.push({
                  name: two.menu_name,
                  menu_url: two.menu_url,
                });
              }
              // 把三级权限数据赋给oprationlist
              // 在二级页面根据oprationlist 匹配三级权限
              let three = [];
              if (two.son_rule) {
                // 如果菜单有二级
                three = two.son_rule.map((item) => {
                  return item.menu_name;
                });
              }
              if (!this.noChildMunuList.includes(one.menu_name)) {
                operationList.push({
                  name: two.menu_name,
                  operations: three,
                });
              }
            });
          }

          permissionList.push({
            name: one.menu_name,
            children,
          });
        });
        this.menuList = pms2MenuList(permissionList);
        // console.log(this.menuList)
        const jsonStrPer = JSON.stringify(permissionList);
        const encryptPer = encrypt(jsonStrPer).toString();
        sessionStorage.setItem("permission", encryptPer);
        this.update_permission_list(encryptPer);
        this.update_operation_list(operationList);
      }
    }
  },

  mounted() {},
  methods: {
    ...mapMutations(["update_operation_list", "update_permission_list", "updateLoginData"]),
    toIndex() {
      this.$router.push("/Home");
    },
  },
};
</script>

<style lang="less">
.app-container {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.full-container {
  width: 100%;
  height: 100%;
}
.el-header {
  padding-left: 0;
}
.pagination-container {
  text-align: center;
}
.el-pagination {
  display: inline-block;
}

.el-drawer__header span:focus,
.el-drawer.drawer:focus,
.el-drawer__close-btn {
  outline: none;
}
.el-image-viewer__close .el-icon-circle-close {
  color: #fff;
}
</style>
<style lang="less" scoped>
.title-box {
  font-size: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1890ff;
  height: 63px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.print-hide {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.full-height {
  height: 100%;
  overflow: hidden;
}
.scroll-menu {
  overflow: auto;
  height: calc(100vh - 63px);
}
.scroll-menu::-webkit-scrollbar {
  /*滚动条整体样式*/

  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/

  height: 1px;
}

.scroll-menu::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/

  border-radius: 6px;

  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

  background: #535353;
}

.scroll-menu::-webkit-scrollbar-track {
  /*滚动条里面轨道*/

  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

  border-radius: 6px;

  background: #ededed;
}
#page-container {
  padding: 10px;
  box-sizing: border-box;
  height: calc(100% - 60px);
  overflow: auto;
  overflow-x: hidden;
}
.news-item {
  display: flex;
  align-items: center;
  padding: 22px 30px;
  border-bottom: 1px solid #ccc;
  .icon {
    width: 52px;
    height: 52px;
  }
  .middle {
    text-align: left;
    width: 300px;
  }
  .sub-content {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  .btn {
    width: 88px;
    height: 40px;
    margin-left: auto;
    background: rgba(255, 192, 50, 1);
    border: none;
  }
}

/deep/.index-dialog {
  /deep/.el-dialog__header {
    padding: 0 !important;
  }
  /deep/.el-dialog__body {
    padding-left: 0;
    padding-right: 0;
  }
  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 98px;
    box-sizing: border-box;
    padding: 12px 30px;
    background: rgba(255, 192, 50, 1);
    .slogan {
      font-size: 22px;
      font-family:
        PingFangSC-Semibold,
        PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
    }
    .title {
      font-size: 28px;
      font-family:
        PingFangSC-Semibold,
        PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
    }
    .allBtn {
      background: rgba(255, 155, 13, 1);
      width: 120px;
      height: 40px;
      color: rgba(255, 255, 255, 1);
      border: none;
    }
  }
}

/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
@media print {
  .print-hide {
    display: none;
  }
  .main .content {
    padding: 0;
    margin-top: 0;
    font-size: 14px;
  }
}
</style>
